
export default function ReadOnlyTextArea({ id, label, value }) {
    return (
        <div className="match-info-item">
            <label htmlFor={id}>{label}</label>
            <textarea
                id={id}
                value={value}
                readOnly
                rows={2}
                tabIndex={-1}
                className="alt-text-area"
            />
        </div>
    );
}
